<div class="pageheader">
  <div class="columns p-2 m-0 mb-5">
    <div class="column is-7">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          @for (b of Breadcrumbs; track b) {
            <li>
              @if (b[0] == 'MODELDISPLAY') {
                <span>
                  <a [routerLink]="modelHomeLink">{{displayTitle}}</a>
                </span>
              } @else {
                @if (b[1] != 'DISABLED') {
                  <span>
                    <a [routerLink]="b[1]">{{b[0]}}</a>
                  </span>
                }
                @if (b[1] == 'DISABLED') {
                  <span>
                    <a class="is-active" disabled style="color:black; pointer-events: none;">{{b[0]}}</a>
                  </span>
                }
              }
            </li>
          }
          <!-- <li class="is-active has-text-weight-bold">
          <a href="#" aria-current="page" *ngIf="Editor">Edit {{displayTitle}}</a>
          <a href="#" aria-current="page" *ngIf="!Editor">{{displayTitle}}</a>
        </li> -->
      </ul>
    </nav>
  </div>
  <div class="column is-5 has-text-right">
    @if (EnableEdit) {
      <button class="button is-link" [routerLink]="editRouterLink" routerLinkActive="active"
        [fragment]="Title">
        <span class="icon-text">
          <span> Edit </span>
          <span class="icon">
            <i class="fa fa-chevron-right"></i>
          </span>
        </span>
      </button>
    }

    @if (EnableDelete) {
      <button type="button" class="button is-danger ml-3 mr-3" (click)="Delete()">
        <span class="icon-text">
          <span>Delete</span>
          <span class="icon">
            <i class="fa fa-trash"></i>
          </span>
        </span>
      </button>
    }

    @if (CurrentMenuItem?.LibraryType) {
      <button type="button" class="button is-primary is-outlined ml-3 mr-4 import-from-library-button" (click)="ImportFromLibrary()">
        <span class="icon-text">
          <span>Import from Library</span>
          <span class="icon">
            <i class="fa fa-download"></i>
          </span>
        </span>
      </button>
    }

    <ng-content></ng-content>
  </div>
  @if (Form) {
    <div>
      <app-validationsummary [Form]="Form"></app-validationsummary>
    </div>
  }
</div>
</div>